import { CreateAbstractSerializer } from '@ftr/serialization';
import { AudioPriceCalculationParams } from './AudioPriceCalculationParams';
import { PriceCalculationParams } from './PriceCalculationParams';
import { RealTimePriceCalculationParams } from './RealTimePriceCalculationParams';
import { TranscriptPriceCalculationParams } from './TranscriptPriceCalculationParams';
export const priceCalculationParamsSerializer = CreateAbstractSerializer(PriceCalculationParams, [
    {
        discriminator: 'AudioPriceCalculationParams',
        constructor: AudioPriceCalculationParams,
    },
    {
        discriminator: 'TranscriptPriceCalculationParams',
        constructor: TranscriptPriceCalculationParams,
    },
    {
        discriminator: 'RealTimePriceCalculationParams',
        constructor: RealTimePriceCalculationParams,
    },
]);
